<template>
  <div class="login-center" v-if="isLogin">
    <div class="account-info">
      <div class="role-info">
        <em class="role-info-ico iconfont icon-center"></em>
        <div class="role-info-text" :class="{ center: !roleName }">
          <div class="account">{{ userName }}</div>
          <div class="role" v-if="roleName">{{ roleName }}</div>
        </div>
      </div>
      <div
        class="role-switch btn-wrap j-role-switch"
        v-if="isHome"
        @click="handleShowSelectRolePopup"
      >
        <em class="role-switch-ico iconfont icon-switch"></em>
        <span class="role-switch-text">{{ letter.voucherSwitchRole }}</span>
      </div>
      <div
        class="role-switch btn-wrap"
        v-else-if="!isInWebview"
        @click="handleGoLogOut"
      >
        <em class="role-switch-ico iconfont icon-switch"></em>
        <span class="role-switch-text"> {{ letter.logout }}</span>
      </div>
      <safe-check v-if="isLandscape"></safe-check>
    </div>
    <safe-check v-if="!isLandscape"></safe-check>
  </div>
  <div class="no-login" :class="{ jpLogin: isJpPlatform }" v-else>
    <div class="login-btn j-login-btn" @click="handleShowLoginPopup">
      <em class="login-btn-ico iconfont icon-center"></em>
      <span class="login-btn-text">{{ isJpPlatform ? 'LoginPassログイン' : letter.voucherLoginLook }}</span>
    </div>
    <div v-if="isJpPlatform" class="uid-login-btn j-uid-login-btn" @click="handleShowUidLoginPopup">
      <em class="login-btn-ico iconfont icon-center"></em>
      <span class="login-btn-text">{{ letter.storeAccountIdLogin }}</span>
    </div>
  </div>
</template>

<script>
import SafeCheck from '@components/officialWebStore/SafeCheck.vue';
import globalConfig from '@utiles/officialStore/globalConfig';
import login from '@mixins/officialWebStore/login';
import { GET_BALANCE_USER_DATA_OF_OPEN } from '@store/officialWebStore/coins';
import { mapGetters, mapState } from 'vuex';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV2';
export default {
  mixins: [login],
  data() {
    return {
      visibleWelfarePopup: false,
      isLandscape: window.innerWidth > window.innerHeight
    };
  },
  computed: {
    userName() {
      // 20240725 需求人: 邓智轩 特殊处理：顽星域名账号展示隐藏前缀 以DISPLAY_NAME字段作为账号显示名称
      if (globalConfig.getMainHost() === 'playplanetgame.com') {
        return this.displayName;
      } else {
        return this.loginAccount;
      }
    },
    isHome() {
      return this.$route.name == 'home';
    },
    ...mapState({
      loginAccount: state => state.login.loginAccount,
      displayName: state => state.login.displayName,
      showCoinEntry: state => state.coins.showCoinEntry,
      isInWebview: state => state.isInWebview
    }),
    ...mapGetters(['getCoinsName', 'gameInfoConfig', 'isJpPlatform'])
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.$store.dispatch(GET_BALANCE_USER_DATA_OF_OPEN);
      }
    }
  },
  methods: {
    handleShowSelectRolePopup() {
      this.showSelectRolePopup();
      clickButton({
        btnName: 'select_role',
        locationKey: locationType.accountInfo
      });
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: locationType.accountInfo
      });
      this.goLogOut();
    },
    handleShowUidLoginPopup() {
      this.showUidLoginPopup();
      clickButton({
        btnName: 'go_login',
        locationKey: locationType.accountInfo
      });
    },
    handleShowLoginPopup() {
      clickButton({
        btnName: 'go_login',
        locationKey: locationType.accountInfo
      });
      this.showLoginPopup();
    }
  },
  components: { SafeCheck }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialWebStore/officialWebStore.scss';
.no-login {
  position: relative;
  width: 710px;
  margin: 0 auto;
  border-radius: 10px;
  height: 107px;
  background-image: linear-gradient(to right, #fff, $lightBg);
  box-shadow: 0px 10px 10px #e7e7e7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .login-btn {
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    font-size: 22px;
    color: #fff;
    background: $btnBg;
    border-radius: 30px;
    cursor: pointer;
    width: max-content;
    &-ico {
      display: inline-block;
      margin-right: 16px;
      font-size: 22px;
      color: #fff;
    }
  }

  .uid-login-btn {
    margin-top: 10px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    font-size: 22px;
    color: #fff;
    background: $btnBg;
    border-radius: 30px;
    cursor: pointer;
    width: max-content;
    &-ico {
      display: inline-block;
      margin-right: 16px;
      font-size: 22px;
      color: #fff;
    }
  }
  &.jpLogin {
    padding: 10px 0;
    .login-btn {
      width: 70%;
    }
    .uid-login-btn {
      width: 70%;
    }
  }
}
.login-center {
  position: relative;
  width: 710px;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0px 10px 10px #e7e7e7;
  .account-info {
    display: flex;
    justify-content: space-between;
    position: relative;
    width: 100%;
    // height: 107px;
    box-sizing: border-box;
    padding: 31px 22px;
    font-size: 22px;
    color: #333;
    border-radius: 10px;
    background-image: linear-gradient(to right, #fff, $lightBg);
    .role-info {
      display: flex;
      align-items: center;
      &-ico {
        display: inline-block;
        font-size: 38px;
      }
      &-line {
        height: 100%;
        vertical-align: middle;
        border-top: 0;
        border-left: 1px solid $border;
        margin: 0 20px;
      }
      &-text {
        font-size: 22px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        height: 100%;
        margin-left: 21px;

        &.center {
          justify-content: center;
        }
        .account,
        .role {
          max-width: 200px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 25px;
        }
      }
    }
  }
  .btn-wrap {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $btnBg;
    border-radius: 30px;
    padding: 0 20px;
    height: 45px;
    box-sizing: border-box;
    cursor: pointer;
    color: #fff;
  }
  .role-switch {
    &-ico {
      display: inline-block;
      margin-right: 10px;
      font-size: 30px;
      color: #fff;
    }
  }
}

@media screen and (orientation: landscape) {
  .no-login {
    width: 100%;
    height: 156px;
    margin-top: 30px;
    .uid-login-btn,
    .login-btn {
      font-size: 16px;
    }
    &.jpLogin {
      padding: unset;
    }
  }
  .login-center {
    position: relative;
    width: 100%;
    margin-top: 30px;
    .account-info {
      width: 100%;
      // height: 156px;
      padding: 30px 30px 11px;
      font-size: 16px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .btn-wrap {
        padding: 14px 20px;
        font-size: 16px;
        width: fit-content;
        margin-top: 20px;
        .role-switch-ico {
          font-size: 20px;
        }
      }
      .role-info {
        &-text {
          font-size: 16px;
          margin-left: 10px;
        }
        &-ico {
          font-size: 40px;
        }
      }
    }
    .login-btn {
      font-size: 22px;
    }
  }
}
</style>
